export default ({ data, id, slugs }) => ({
	id,
	slug: slugs[0],
    full_name: data.full_name,
	photo: data.photo.url,
    role:data.role,
    bio: data.bio.map(({ text }) => text).join("<br/>"),
    link: data.link.url
});
